export enum ENUM__token_type {
  WORD = 'word',
  LORA = 'lora',
  EMBEDDING = 'embedding',
}
